var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeachChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.56 4.017 1.134-1.286M23.241 6.653l1.71-.174M18.711 2.755l-.083-1.716",
    stroke: "#31B59F",
    strokeWidth: 0.857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.46 27.277-4.114-6.525a1.86 1.86 0 1 1 3.149-1.982l3.85 6.123a3.512 3.512 0 0 0 2.973 1.643h10.975c.945 0 1.872.254 2.685.735l4.927 2.918a1.616 1.616 0 0 1-1.642 2.784l-4.275-2.511a5.268 5.268 0 0 0-2.668-.726H10.917a5.269 5.269 0 0 1-4.457-2.46zM20.447 34.374v-4.697m2.294 4.697v-4.697M11.045 34.374v-4.697m2.293 4.697v-4.697",
    stroke: "#AAABAD",
    strokeWidth: 0.931,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.52 12.874 15.21 24.43M17.427 31.402l.902 2.774M17.773 5.21c2.39 1.238 3.89 3.211 4.321 4.843L.877 15.752c-.845-3.194.891-9.393 8.285-11.285 2.227-.57 4.211-.573 5.92-.213",
    stroke: "#AAABAD",
    strokeWidth: 0.931,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.161 4.5c-1.506.987-3.295 4.014-1.864 9.418M9.16 4.534c1.798.113 4.85 1.859 6.28 7.263",
    stroke: "#AAABAD",
    strokeWidth: 0.931,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.84 6.185c1.055.365 2.959 1.044 4.284 2.905",
    stroke: "#31B59F",
    strokeWidth: 0.931,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .59)",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeachChair);
export default __webpack_public_path__ + "static/media/beach-chair.eec1f8e69f5546a5bb557b0f4e8e20f7.svg";
export { ForwardRef as ReactComponent };